export const getIdFromSlug = (slug: string) => {
  const parts = slug.split('-');
  return parts[parts.length - 1];
};

export const getImagePath = (url: string) => `${process.env.NEXT_PUBLIC_ASSET_URL}${url}`;
